import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, filter, mergeMap, withLatestFrom, map } from 'rxjs/operators';
import {
  DELIVERY_ZONE_CUSTOMER_FIND,
  DELIVERY_ZONE_CUSTOMER_FIND_SUCCESS,
  DELIVERY_ZONE_CUSTOMER_FAILURE,
  DELIVERY_ZONE_CUSTOMER_UPDATE_LOADING,
  DELIVERY_ZONE_CUSTOMER_EDIT_MODE,
} from '../actions';
import { DeliveryZoneCustomer, DeliveryZoneCustomerForm  } from '@core/models';
import { DeliveryZoneCustomerService } from '@core/services';
import { selectClient, selectDeliveryZoneCustomer, selectDeliveryZoneCustomerForm } from '@store/selectors';

@Injectable()
export class DeliveryZoneCustomerEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private deliveryZoneCustomerService: DeliveryZoneCustomerService,
  ) {}

  findDeliveryZoneCustomer$ = createEffect(() =>
      this.actions$.pipe(
        ofType(DELIVERY_ZONE_CUSTOMER_FIND),
        withLatestFrom(this.store.select(selectClient)),
        filter(([_,client]) => !!client),
        map(([_,client]) => {
          return {clientId: client?.id as string}
        }),
        mergeMap(({ clientId }) => {
          this.store.dispatch(DELIVERY_ZONE_CUSTOMER_UPDATE_LOADING({  loading: true }));
          return this.deliveryZoneCustomerService.findAll(clientId).pipe(
            mergeMap(({ data }) => {
              const [deliveryZoneCustomer] = data as DeliveryZoneCustomer[];

              return [
                DELIVERY_ZONE_CUSTOMER_EDIT_MODE({ editMode: true }),
                DELIVERY_ZONE_CUSTOMER_UPDATE_LOADING({ loading: false }),

                DELIVERY_ZONE_CUSTOMER_FIND_SUCCESS({ deliveryZoneCustomer }),
              ];
            }),
            catchError((error) => of(DELIVERY_ZONE_CUSTOMER_FAILURE({ error })))
          )
        }),
      )
    );
  }
